import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import CheckboxSelectAll from "stimulus-checkbox-select-all"

const application = Application.start()
const context = require.context(".", true, /\.js$/)
application.register("checkbox-select-all", CheckboxSelectAll)
application.load(definitionsFromContext(context))
